









import { Vue, Component, Prop } from 'vue-property-decorator';
import { IPricingTableColumn } from '@lib-shared/editor/types';

@Component
export default class PricingTableColumnHeaders extends Vue {
  @Prop() columns: IPricingTableColumn[];
  @Prop() gridTemplateColumns: string;
  @Prop() enabledColumns: IPricingTableColumn[];

  getColumnDisplayName(columnId: string): string {
    const column = this.columns.find(({ id }) => id === columnId);
    if (!column) {
      return '';
    }
    return column.displayName || column.name;
  }
}
